import { styled } from "@mui/system";
import { Typography } from "@mui/material";

export const PageNotFoundTypography = styled(Typography)(() => ({
    fontFamily: "Open Sans",
    fontWeight: 700,
    fontSize: "28px",
    color: "#4C4C4C",
}));